import { useDispatch } from "react-redux";
import { AppActions } from "../../../../store/ducks/app";

export const useQuickActionsViewModel = () => {
	const dispatch = useDispatch();

	const handleAddPatient = () => {
		dispatch(AppActions.set_modal_adicionar_paciente(true));
	};

	return {
		handleAddPatient,
	};
};
